import React, { useState, useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';

interface ApiResponse {
  id?: string;
  photoUrl?: string;
  aiResponse?: string;
  timestamp?: string;
}

const Data: React.FC = () => {  const [data, setData] = useState<ApiResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [wakeLock, setWakeLock] = useState<any>(null);

  useEffect(() => {
    fetchData();
    requestWakeLock();
    
    // Cleanup wake lock on component unmount
    return () => {
      if (wakeLock) {
        wakeLock.release();
      }
    };
  }, []);
  const requestWakeLock = async () => {
    try {
      if ('wakeLock' in navigator && (navigator as any).wakeLock) {
        const lock = await (navigator as any).wakeLock.request('screen');
        setWakeLock(lock);
        console.log('Wake lock activated');
      }
    } catch (error) {
      console.log('Wake lock failed:', error);
    }
  };

    const auth = useAuth();

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await fetch('https://api-hack.georgii.tech/answer', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
            Authorization: `Bearer ${auth!.user!.id_token}`,        
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      setData(result);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred');
    } finally {
      setLoading(false);
    }  };

  const parseAiResponse = (aiResponse: string) => {
    try {
      const parsed = JSON.parse(aiResponse);
      
      return (
        <div style={{ textAlign: 'left' }}>          <h2 style={{ 
            color: '#10b981', 
            marginBottom: '30px', 
            fontSize: '1.8rem',
            textAlign: 'center',
            fontWeight: 'bold'
          }} className="mobile-heading">
            🧠 AI Analysis
          </h2>
          
          {/* Problem Overview */}
          <div style={{
            backgroundColor: '#1e293b',
            padding: '20px',
            borderRadius: '12px',
            border: '2px solid #059669',
            marginBottom: '20px',
            boxShadow: '0 4px 12px rgba(16, 185, 129, 0.1)'
          }} className="mobile-responsive">
            <h3 style={{ color: '#34d399', marginBottom: '15px', fontSize: '1.3rem' }} className="mobile-subheading">
              📋 Problem Overview
            </h3>
            <div style={{ marginBottom: '12px' }}>
              <span style={{ color: '#fbbf24', fontWeight: 'bold' }}>Type: </span>
              <span style={{ color: '#e5e7eb', backgroundColor: '#374151', padding: '4px 8px', borderRadius: '6px', fontSize: '0.9rem' }}>
                {parsed.TypeOfTask}
              </span>
            </div>
            <div style={{ color: '#d1d5db', lineHeight: '1.6', fontSize: '1rem' }}>
              {parsed.ProblemSummary}
            </div>
          </div>          {/* Before Coding */}
          <div style={{
            backgroundColor: '#1e293b',
            padding: '20px',
            borderRadius: '12px',
            border: '2px solid #3b82f6',
            marginBottom: '20px',
            boxShadow: '0 4px 12px rgba(59, 130, 246, 0.1)'
          }} className="mobile-responsive">
            <h3 style={{ color: '#60a5fa', marginBottom: '15px', fontSize: '1.3rem' }} className="mobile-subheading">
              💡 What to Say Before Coding
            </h3>            <div style={{ 
              color: '#d1d5db', 
              lineHeight: '1.6', 
              fontSize: '1rem',
              padding: '15px',
              backgroundColor: '#0f172a',
              borderRadius: '8px',
              borderLeft: '4px solid #3b82f6'
            }} className="compact-text">
              {parsed.WhatToSayBeforeCoding}
            </div>
          </div>          {/* Clarifying Questions */}
          <div style={{
            backgroundColor: '#1e293b',
            padding: '20px',
            borderRadius: '12px',
            border: '2px solid #8b5cf6',
            marginBottom: '20px',
            boxShadow: '0 4px 12px rgba(139, 92, 246, 0.1)'
          }} className="mobile-responsive">
            <h3 style={{ color: '#a78bfa', marginBottom: '15px', fontSize: '1.3rem' }} className="mobile-subheading">
              ❓ Clarifying Questions
            </h3>
            <ul style={{ paddingLeft: '0', margin: '0' }}>
              {parsed.ClarifyingQuestions?.map((question: string, index: number) => (
                <li key={index} style={{
                  color: '#d1d5db',
                  marginBottom: '12px',
                  padding: '12px',
                  backgroundColor: '#0f172a',
                  borderRadius: '8px',
                  listStyle: 'none',
                  borderLeft: '4px solid #8b5cf6',
                  fontSize: '0.95rem',
                  lineHeight: '1.5'
                }}>
                  <span style={{ color: '#c084fc', fontWeight: 'bold' }}>Q{index + 1}: </span>
                  {question}
                </li>
              ))}
            </ul>
          </div>          {/* Step by Step Plan */}
          <div style={{
            backgroundColor: '#1e293b',
            padding: '20px',
            borderRadius: '12px',
            border: '2px solid #f59e0b',
            marginBottom: '20px',
            boxShadow: '0 4px 12px rgba(245, 158, 11, 0.1)'
          }} className="mobile-responsive">
            <h3 style={{ color: '#fbbf24', marginBottom: '15px', fontSize: '1.3rem' }} className="mobile-subheading">
              📝 Step-by-Step Plan
            </h3>            <div className="step-grid">
              {parsed.StepByStepPlan?.map((step: string, index: number) => (
                <div key={index} style={{
                  color: '#d1d5db',
                  padding: '10px',
                  backgroundColor: '#0f172a',
                  borderRadius: '8px',
                  borderLeft: '4px solid #f59e0b',
                  fontSize: '0.9rem',
                  lineHeight: '1.4',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '8px'
                }} className="step-item">
                  <span style={{ 
                    color: '#fbbf24', 
                    fontWeight: 'bold',
                    backgroundColor: '#92400e',
                    borderRadius: '50%',
                    width: '20px',
                    height: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.75rem',
                    flexShrink: 0,
                    marginTop: '2px'
                  }}>
                    {index + 1}
                  </span>
                  <span style={{ flex: 1 }}>
                    {step.replace(/^\d+\.\s*/, '')}
                  </span>
                </div>
              ))}
            </div>
          </div>{/* Java Code */}
          <div style={{
            backgroundColor: '#1e293b',
            padding: '20px',
            borderRadius: '12px',
            border: '2px solid #ef4444',
            marginBottom: '20px',
            boxShadow: '0 4px 12px rgba(239, 68, 68, 0.1)'
          }} className="mobile-responsive">
            <h3 style={{ color: '#f87171', marginBottom: '15px', fontSize: '1.3rem' }} className="mobile-subheading">
              ⚡ Java Solution
            </h3>
            <div style={{
              backgroundColor: '#0f172a',
              borderRadius: '8px',
              border: '1px solid #374151',
              overflow: 'auto'
            }}>
              <SyntaxHighlighter
                language="java"
                style={vscDarkPlus}
                customStyle={{
                  margin: 0,
                  padding: '20px',
                  fontSize: '0.85rem',
                  lineHeight: '1.4',
                  borderRadius: '8px',
                  backgroundColor: '#0f172a'
                }}
                className="mobile-code"
              >
                {parsed.JavaCode}
              </SyntaxHighlighter>
            </div>
          </div>{/* Test Cases */}
          <div style={{
            backgroundColor: '#1e293b',
            padding: '20px',
            borderRadius: '12px',
            border: '2px solid #06b6d4',
            marginBottom: '20px',
            boxShadow: '0 4px 12px rgba(6, 182, 212, 0.1)'
          }} className="mobile-responsive">
            <h3 style={{ color: '#22d3ee', marginBottom: '15px', fontSize: '1.3rem' }} className="mobile-subheading">
              🧪 Test Cases
            </h3>
            {parsed.TestCases?.map((testCase: any, index: number) => (
              <div key={index} style={{
                backgroundColor: '#0f172a',
                padding: '15px',
                borderRadius: '8px',
                marginBottom: '12px',
                borderLeft: '4px solid #06b6d4'
              }}>
                <div style={{ color: '#22d3ee', fontWeight: 'bold', marginBottom: '8px' }}>
                  Test Case {index + 1}
                </div>
                <div style={{ color: '#d1d5db', fontSize: '0.9rem', marginBottom: '8px' }}>
                  <strong style={{ color: '#fbbf24' }}>Input:</strong> {testCase.input}
                </div>
                <div style={{ color: '#d1d5db', fontSize: '0.9rem', marginBottom: '8px' }}>
                  <strong style={{ color: '#34d399' }}>Output:</strong> {testCase.expectedOutput}
                </div>
                <div style={{ color: '#9ca3af', fontSize: '0.85rem', fontStyle: 'italic' }}>
                  {testCase.description}
                </div>
              </div>
            ))}
          </div>          {/* Complexity Analysis */}
          <div style={{
            backgroundColor: '#1e293b',
            padding: '20px',
            borderRadius: '12px',
            border: '2px solid #ec4899',
            marginBottom: '20px',
            boxShadow: '0 4px 12px rgba(236, 72, 153, 0.1)'
          }} className="mobile-responsive">
            <h3 style={{ color: '#f472b6', marginBottom: '15px', fontSize: '1.3rem' }} className="mobile-subheading">
              ⏱️ Complexity Analysis
            </h3>
            <div style={{ marginBottom: '15px' }}>
              <div style={{ 
                color: '#fbbf24', 
                fontWeight: 'bold', 
                marginBottom: '8px',
                fontSize: '1rem'
              }}>
                Time Complexity:
              </div>
              <div style={{ 
                color: '#d1d5db', 
                backgroundColor: '#0f172a',
                padding: '10px',
                borderRadius: '6px',
                borderLeft: '4px solid #ec4899',
                fontSize: '0.9rem'
              }}>
                {parsed.TimeComplexity}
              </div>
            </div>
            <div>
              <div style={{ 
                color: '#fbbf24', 
                fontWeight: 'bold', 
                marginBottom: '8px',
                fontSize: '1rem'
              }}>
                Space Complexity:
              </div>
              <div style={{ 
                color: '#d1d5db', 
                backgroundColor: '#0f172a',
                padding: '10px',
                borderRadius: '6px',
                borderLeft: '4px solid #ec4899',
                fontSize: '0.9rem'
              }}>
                {parsed.SpaceComplexity}
              </div>
            </div>
          </div>          {/* After Coding */}
          <div style={{
            backgroundColor: '#1e293b',
            padding: '20px',
            borderRadius: '12px',
            border: '2px solid #10b981',
            marginBottom: '20px',
            boxShadow: '0 4px 12px rgba(16, 185, 129, 0.1)'
          }} className="mobile-responsive">
            <h3 style={{ color: '#34d399', marginBottom: '15px', fontSize: '1.3rem' }} className="mobile-subheading">
              🎯 What to Say After Coding
            </h3>            <div style={{ 
              color: '#d1d5db', 
              lineHeight: '1.6', 
              fontSize: '1rem',
              padding: '15px',
              backgroundColor: '#0f172a',
              borderRadius: '8px',
              borderLeft: '4px solid #10b981'
            }} className="compact-text">
              {parsed.WhatToSayAfterCoding}
            </div>
          </div>
        </div>
      );
    } catch {
      // If not valid JSON, display as text
      return (
        <div style={{ textAlign: 'left' }}>
          <h3 style={{ color: '#4ade80', marginBottom: '20px' }}>AI Analysis (Text)</h3>
          <div style={{
            backgroundColor: '#1e293b',
            padding: '20px',
            borderRadius: '8px',
            border: '1px solid #334155',
            fontSize: '14px',
            lineHeight: '1.6',
            color: '#e2e8f0',
            whiteSpace: 'pre-wrap'
          }}>
            {aiResponse}
          </div>
        </div>
      );
    }
  };
  return (    <div style={{
      backgroundColor: '#000000',
      color: '#ffffff',
      minHeight: '100vh',
      padding: '8px',
      fontFamily: 'Monaco, Consolas, "Courier New", monospace'
    }}><style>        {`
          .mobile-responsive {
            padding: 12px !important;
            margin-bottom: 12px !important;
          }
          
          .step-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
            gap: 10px;
          }
          
          @media (max-width: 768px) {
            .mobile-responsive {
              padding: 10px !important;
              margin-bottom: 10px !important;
              font-size: 0.9rem !important;
            }
            .mobile-code {
              font-size: 0.75rem !important;
              padding: 10px !important;
            }
            .mobile-heading {
              font-size: 1.4rem !important;
              margin-bottom: 15px !important;
            }
            .mobile-subheading {
              font-size: 1.1rem !important;
              margin-bottom: 8px !important;
            }
            .step-grid {
              grid-template-columns: 1fr;
              gap: 8px;
            }
            .step-item {
              font-size: 0.85rem !important;
              padding: 8px !important;
            }
          }
          
          @media (max-width: 480px) {
            .mobile-responsive {
              padding: 8px !important;
              margin-bottom: 8px !important;
              font-size: 0.85rem !important;
            }
            .mobile-code {
              font-size: 0.7rem !important;
              padding: 8px !important;
            }
            .mobile-heading {
              font-size: 1.2rem !important;
              margin-bottom: 10px !important;
            }
            .mobile-subheading {
              font-size: 1rem !important;
              margin-bottom: 6px !important;
            }
            .step-item {
              font-size: 0.8rem !important;
              padding: 6px !important;
            }
          }
          
          @media (max-height: 600px) and (orientation: landscape) {
            .mobile-responsive {
              padding: 6px !important;
              margin-bottom: 6px !important;
            }
            .mobile-heading {
              font-size: 1.1rem !important;
              margin-bottom: 8px !important;
            }
            .mobile-subheading {
              font-size: 0.9rem !important;
              margin-bottom: 4px !important;
            }
            .mobile-code {
              font-size: 0.65rem !important;
              padding: 6px !important;
              line-height: 1.2 !important;
            }
            .step-grid {
              grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
              gap: 6px;
            }
            .step-item {
              font-size: 0.75rem !important;
              padding: 4px !important;
              line-height: 1.2 !important;
            }
            /* Compact text styling for landscape */
            .compact-text {
              font-size: 0.8rem !important;
              line-height: 1.3 !important;
              padding: 6px !important;
            }
          }
        `}
      </style>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '30px',
          borderBottom: '1px solid #333',
          paddingBottom: '20px',
          flexWrap: 'wrap',
          gap: '10px'
        }}>
          <h1 style={{
            fontSize: '1.5rem',
            margin: 0,
            color: '#ffffff'
          }} className="mobile-heading">
            API Data Display
          </h1>
          <button
            onClick={fetchData}
            style={{
              backgroundColor: '#1f2937',
              color: '#ffffff',
              border: '1px solid #374151',
              padding: '8px 16px',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px',
              minWidth: '80px'
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#374151'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#1f2937'}
          >
            Refresh
          </button>
        </div>

        {loading && (
          <div style={{
            textAlign: 'center',
            padding: '40px',
            color: '#9ca3af'
          }}>
            <div style={{
              display: 'inline-block',
              width: '20px',
              height: '20px',
              border: '2px solid #374151',
              borderTop: '2px solid #ffffff',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite'
            }}></div>
            <p style={{ marginTop: '10px' }}>Loading data...</p>
            <style>
              {`
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
              `}
            </style>
          </div>
        )}

        {error && (
          <div style={{
            backgroundColor: '#7f1d1d',
            border: '1px solid #dc2626',
            padding: '20px',
            borderRadius: '8px',
            marginBottom: '20px'
          }}>
            <h3 style={{ color: '#fca5a5', margin: '0 0 10px 0' }}>Error</h3>
            <p style={{ margin: 0, color: '#fecaca' }}>{error}</p>
          </div>
        )}        {!loading && !error && data && (
          <div>
            {data.aiResponse && (
              <div style={{
                backgroundColor: '#111827',
                border: '1px solid #374151',
                padding: '20px',
                borderRadius: '8px'
              }}>
                {parseAiResponse(data.aiResponse)}
              </div>
            )}

            {data.timestamp && (
              <div style={{
                textAlign: 'center',
                marginTop: '20px',
                color: '#6b7280',
                fontSize: '14px'
              }}>
                Last updated: {new Date(data.timestamp).toLocaleString()}
              </div>
            )}
          </div>
        )}

        {!loading && !error && !data && (
          <div style={{
            textAlign: 'center',
            padding: '40px',
            color: '#6b7280'
          }}>
            <p>No data available</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Data;
